import { useTranslation } from 'react-i18next';

import { BusesSearchForm } from '@frontend/features/travel-services/components/BusesSearchForm';
import { TravelServicesPage } from '@frontend/features/travel-services/components/TravelServicesPage';
import { useSearchFormKey } from '@frontend/features/travel-services/useSearchUrlState';

/** Buscador de micros (vertical buses de Rutero). */
export const Buses = () => {
  const { t } = useTranslation();
  // Aplicar una búsqueda reciente remonta el buscador: si no, los campos
  // (que se llenan al montar) quedarían vacíos bajo los resultados nuevos.
  const formKey = useSearchFormKey();

  return (
    <TravelServicesPage
      title={t('common.nav.buses')}
      intro={t('travelServices.busesIntro')}
    >
      <BusesSearchForm key={formKey} />
    </TravelServicesPage>
  );
};

export default Buses;
